var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewcartimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.375 23.8913V36.1387C60.375 38.5537 58.42 40.48 56.0337 40.48H15.0938V43.8438C15.0938 46.23 17.02 48.1562 19.4062 48.1562H21.7925C19.8087 48.1562 18.055 49.105 16.9625 50.6C14.2025 49.5938 12.2188 46.9488 12.2188 43.8438V11.5H10.0625C9.2575 11.5 8.625 10.8675 8.625 10.0625C8.625 9.2575 9.2575 8.625 10.0625 8.625H13.6562C14.4613 8.625 15.0938 9.2575 15.0938 10.0625V14.3175L56.58 19.5787C58.7363 19.8375 60.375 21.7063 60.375 23.8913Z",
    fill: "#6495ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.395 48.1562C52.2387 48.1562 50.3125 49.3062 49.2487 51.0312H26.9387C25.875 49.3062 23.9487 48.1562 21.7925 48.1562H54.395Z",
    fill: "#90B2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8013 54.1362C27.8013 57.4425 25.0987 60.145 21.7925 60.145C18.4862 60.145 15.8125 57.4425 15.8125 54.1362C15.8125 52.8137 16.2438 51.6063 16.9625 50.6C18.055 49.105 19.8087 48.1562 21.7925 48.1562C23.9487 48.1562 25.875 49.3062 26.9387 51.0312C27.485 51.9512 27.8013 53.015 27.8013 54.1362ZM60.375 54.1362C60.375 57.4425 57.7013 60.145 54.395 60.145C51.0888 60.145 48.3862 57.4425 48.3862 54.1362C48.3862 53.015 48.7025 51.9512 49.2487 51.0312C50.3125 49.3062 52.2388 48.1562 54.395 48.1562C54.4813 48.1562 54.5963 48.1563 54.6825 48.185C57.845 48.3288 60.375 50.9162 60.375 54.1362Z",
    fill: "#0047AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcartimg);
export default __webpack_public_path__ + "static/media/newcartimg.02b674f1c35d161d477621c783ddbefb.svg";
export { ForwardRef as ReactComponent };